

export const getImageUrl = (url, width, height = null) => {
  if (!url || !url.startsWith('https://firebasestorage.googleapis.com/v0/b/blabla-c57da.appspot.com/')) return url;

  return `https://d2hlec88f33bjv.cloudfront.net/api/images?__json=${encodeURIComponent(JSON.stringify({
    url, width, height
  }))}`;
};